<h2 mat-dialog-title>We’re Sorry to See You Go</h2>
<mat-dialog-content>
  <p>
    Due to the complex nature of our subscription configurations, we kindly ask
    that you contact our Customer Success team to discuss your cancellation
    options.
  </p>
  <p>
    Our team is dedicated to ensuring a smooth process and addressing any
    concerns you may have. Please reach out to us at:
  </p>
  <p>
    Email: <a href="mailto:Success&#64;Zentra.co">Success&#64;Zentra.co</a
    ><br />
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
